import React from "react";
import ScrollToTop from "./components/ScrollToTop";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import LoginPage from "./LoginPage";
import CourseOverview from "./CourseOverview";
import ForgotPassword from "./ForgotPassword";
import Chapter1_1 from "./1_1";
import Chapter1_2 from "./1_2";
import Chapter1_3 from "./1_3";
import Chapter1_4 from "./1_4";
import Chapter1_5 from "./1_5";
import Chapter2_1 from "./2_1";
import Chapter2_2 from "./2_2";
import Chapter2_3 from "./2_3";
import Chapter2_4 from "./2_4";
import Chapter2_5 from "./2_5";
import Chapter3_1 from "./3_1";
import Chapter3_2 from "./3_2";
import Chapter3_3 from "./3_3";
import Chapter3_4 from "./3_4";
import Chapter3_5 from "./3_5";
import Chapter4_1 from "./4_1";
import Chapter4_2 from "./4_2";
import Chapter4_3 from "./4_3";
import Chapter4_4 from "./4_4";
import Chapter4_5 from "./4_5";
import Chapter5_1 from "./5_1";
import Chapter5_2 from "./5_2";
import Chapter5_3 from "./5_3";
import Chapter5_4 from "./5_4";
import Chapter5_5 from "./5_5";
import Chapter6_1 from "./6_1";
import Chapter6_2 from "./6_2";
import Chapter6_3 from "./6_3";
import Chapter6_4 from "./6_4";
import Chapter6_5 from "./6_5";
import Chapter7_1 from "./7_1";
import Chapter7_2 from "./7_2";
import Chapter7_3 from "./7_3";
import Chapter7_4 from "./7_4";
import Chapter7_5 from "./7_5";
import Chapter8_1 from "./8_1";
import Chapter8_2 from "./8_2";
import Chapter8_3 from "./8_3";
import Chapter8_4 from "./8_4";
import Chapter8_5 from "./8_5";
import WordPressSSO from "./WordPressSSO";

function App() {
  return (
    <Router>
      <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/course-overview" element={<CourseOverview />} />
          <Route path="/1_1" element={<Chapter1_1 />} />
          <Route path="/1_2" element={<Chapter1_2 />} />
          <Route path="/1_3" element={<Chapter1_3 />} />
          <Route path="/1_4" element={<Chapter1_4 />} />
          <Route path="/1_5" element={<Chapter1_5 />} />
          <Route path="/2_1" element={<Chapter2_1 />} />
          <Route path="/2_2" element={<Chapter2_2 />} />
          <Route path="/2_3" element={<Chapter2_3 />} />
          <Route path="/2_4" element={<Chapter2_4 />} />
          <Route path="/2_5" element={<Chapter2_5 />} />
          <Route path="/3_1" element={<Chapter3_1 />} />
          <Route path="/3_2" element={<Chapter3_2 />} />
          <Route path="/3_3" element={<Chapter3_3 />} />
          <Route path="/3_4" element={<Chapter3_4 />} />
          <Route path="/3_5" element={<Chapter3_5 />} />
          <Route path="/4_1" element={<Chapter4_1 />} />
          <Route path="/4_2" element={<Chapter4_2 />} />
          <Route path="/4_3" element={<Chapter4_3 />} />
          <Route path="/4_4" element={<Chapter4_4 />} />
          <Route path="/4_5" element={<Chapter4_5 />} />
          <Route path="/5_1" element={<Chapter5_1 />} />
          <Route path="/5_2" element={<Chapter5_2 />} />
          <Route path="/5_3" element={<Chapter5_3 />} />
          <Route path="/5_4" element={<Chapter5_4 />} />
          <Route path="/5_5" element={<Chapter5_5 />} />
          <Route path="/6_1" element={<Chapter6_1 />} />
          <Route path="/6_2" element={<Chapter6_2 />} />
          <Route path="/6_3" element={<Chapter6_3 />} />
          <Route path="/6_4" element={<Chapter6_4 />} />
          <Route path="/6_5" element={<Chapter6_5 />} />
          <Route path="/7_1" element={<Chapter7_1 />} />
          <Route path="/7_2" element={<Chapter7_2 />} />
          <Route path="/7_3" element={<Chapter7_3 />} />
          <Route path="/7_4" element={<Chapter7_4 />} />
          <Route path="/7_5" element={<Chapter7_5 />} />
          <Route path="/8_1" element={<Chapter8_1 />} />
          <Route path="/8_2" element={<Chapter8_2 />} />
          <Route path="/8_3" element={<Chapter8_3 />} />
          <Route path="/8_4" element={<Chapter8_4 />} />
          <Route path="/8_5" element={<Chapter8_5 />} />
          <Route path="/sso" element={<WordPressSSO />} />
        </Routes>
      </Router>
  );
}

export default App;
